import { FC, Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { MenuTreeItemProps } from "apis";
import { AppScroll } from "components";
import { apiAuthMenu } from "apis/auth/auth-menu";
import useAppSelector from "hooks/useAppSelector";

interface AdminMenuProps {
}

const AdminMenu: FC<AdminMenuProps> = () => {
    const [menus, setMenus] = useState<MenuTreeItemProps[]>([]);
    useEffect(() => {
        apiAuthMenu()
            .then(res => {
                setMenus(res.data || []);
            })
    }, []);

    const { pathname } = useLocation();

    const [scrollTop, setScrollTop] = useState<number>(0);
    const locale = useAppSelector(state => state.auth.user?.locale)

    return (
        <Fragment>
            <AppScroll
                className={`flex-1 p-0 lg:p-4 space-y-2 overflow-y-auto overflow-x-hidden group-[.sidebar-open]:p-4`}
                onScroll={(e) => { setScrollTop(e.currentTarget.scrollTop); }}
            >
                {
                    menus
                        .map((menu, i) => {
                            const isActive = pathname.replace(/\.html$/, "").includes(menu.url.replace(/\.html$/, ""));
                            return <Link
                                key={i}
                                to={menu.url}
                                className={`
                                    group/menu-item
                                    whitespace-nowrap
                                    block px-2 py-2 rounded text-gray-800 transition-colors 
                                    ${isActive ? "bg-blue-500 group-[.sidebar-open]:text-white text-white hover:text-white" : "hover:bg-blue-100"}
                                `}
                            >
                                <span className="inline-block w-7 text-center">
                                    <i className={menu.iconClassName} />
                                </span>
                                <span
                                    className={`
                                        opacity-0
                                        overflow-hidden transform transition-all duration-300 
                                        lg:opacity-0
                                        group-hover/menu-item:opacity-100

                                        !duration-0 
                                        group-hover/menu-item:fixed 
                                        group-hover/menu-item:ml-[25px] 
                                        group-hover/menu-item:-mt-[${scrollTop + 5}px] 
                                        group-hover/menu-item:bg-white 
                                        group-hover/menu-item:shadow 
                                        group-hover/menu-item:px-[20px] 
                                        group-hover/menu-item:rounded 
                                        group-hover/menu-item:py-[5px] 
                                        group-hover/menu-item:text-gray-800
                                        group-hover/menu-item:z-[51]
                                        
                                        group-[.sidebar-open]:lg:opacity-100
                                        group-[.sidebar-open]:lg:relative
                                        group-[.sidebar-open]:lg:shadow-none
                                        group-[.sidebar-open]:lg:text-inherit
                                        group-[.sidebar-open]:lg:p-2
                                        group-[.sidebar-open]:lg:ml-0
                                        group-[.sidebar-open]:lg:bg-transparent
                                        ${isActive ? "  group-[.sidebar-open]:text-white text-white group-[.sidebar-open]:hover:text-white " : ""}
                                    `}
                                >
                                    {(locale && menu.textTranslate?.name?.[locale]) || menu.name}
                                </span>
                            </Link>
                        })
                }
            </AppScroll>
        </Fragment>
    );
};
export default AdminMenu;
